import Resource from 'components/global/Resource'
import React from 'react'
import { Carousel } from 'react-responsive-carousel'

export default function SchoolResultsSlider() {
	return (
		<Carousel showThumbs={false} dynamicHeight showStatus={false} infiniteLoop>
			<div className="flex flex-wrap items-center">
				<div className="mb-8 w-full lg:mb-0 lg:w-1/3">
					<Resource title="Saratoga Springs Brief" external noZoom maxHeight={350} />
				</div>

				<div className="hidden w-full text-left sm:block lg:w-2/3">
					<span className="mb-3 block text-lg font-semibold text-gray-800 sm:text-xl">
						After just one year of implementation of ARC Core in grades K–2, Saratoga Springs City School District students have seen impressive growth:
					</span>
					<ul className="list-disc px-10 text-xl text-gray-500">
						<li className="mb-3">
							The percentage of second graders reading on or above grade level nearly doubled and the percentage of first graders reading on or above grade level more
							than tripled.
						</li>
						<li className="mb-6">78% of first and second graders who began the year working at “emergency” were no longer working at “emergency.”</li>
						<a
							href="https://mcusercontent.com/ad29d51ea8f73a14082662cd9/files/92f9a438-b32f-2df9-7313-b45673d3e210/Saratoga_Springs_District_Profile_2023_v8.pdf"
							target="_blank"
						>
							Read the full brief
						</a>
					</ul>
				</div>
			</div>
			<div>
				<Resource title="ARC Core Results Packet" linkOnly linkOnlyStyle="h-full inline-block">
					<img src="/images/digital-solutions/arc-core-results.png" alt="arc core results" />
				</Resource>
			</div>
			<div>
				<Resource title="IES Study" linkOnly linkOnlyStyle="h-full inline-block">
					<img src="/images/digital-solutions/ies.png" alt="ies study results" />
				</Resource>
			</div>
			<div>
				<Resource title="Sequoia Results" linkOnly linkOnlyStyle="h-full inline-block">
					<img src="/images/digital-solutions/san-diego.png" alt="san diego unified school district results" />
				</Resource>
			</div>
			<div>
				<Resource title="Shoshoni Results" linkOnly linkOnlyStyle="h-full inline-block">
					<img src="/images/digital-solutions/fremont-county.png" alt="fremont county school district results" />
				</Resource>
			</div>
			<div>
				<img src="/images/digital-solutions/monroeville.png" alt="monroeville" />
			</div>
			<div>
				<img src="/images/digital-solutions/cape-henlopen.png" alt="cape henlopen" />
			</div>
			<div>
				<img src="/images/digital-solutions/petree.png" alt="petree" />
			</div>
			<div>
				<img src="/images/digital-solutions/cook-literacy-model.png" alt="cook literacy model" />
			</div>
		</Carousel>
	)
}
